<template>
  <v-row justify="center">
    <v-dialog
      v-model="esActiva"
      persistent
      width="600px"
    >
      <template>
        <v-btn
          class="text-h4"
          color="primary"
          dark
        >          
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span style="font-size: 15px !important">Versión: {{version}}</span>                    
        </v-card-title>  
        <v-divider></v-divider>      
        <v-card-text style="font-size: 15px !important">
          <br>
          Copyright © 2021 PowerStreet Todos los derechos reservados
        </v-card-text>
        <v-card-actions>          
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text  @click="cerrar_modal_2()">Cerrar
          </v-btn>         
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    esActiva: Boolean,
    version: String
  },
  data: () => ({    
  }),
  methods: {
    cerrar_modal_2() {
      this.$emit("respuesta_modal_cancelar", false);
    }
  },
};
</script>